<script>
  export let debug;
  export let name;
  export let value;
</script>

{#if debug}
  <p>{name}</p>
{/if}
<input
  {name}
  type={debug ? 'text' : 'hidden'}
  {value}
  required/>
{#if debug}
  <br />
{/if}
